import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa szablonu',
      type: 'string',
      fieldRequired: true
    },
    subject: {
      title: 'Temat wiadomości e-mail',
      type: 'string',
      fieldRequired: true
    },
    fromName: {
      title: 'Nazwa nadawcy',
      type: 'string',
      fieldRequired: true
    },
    fromAddress: {
      title: 'Adres e-mail nadawcy',
      type: 'string',
      format: 'email',
      fieldRequired: true
    },
    to: {
      title: 'Domyślny odbiorca',
      type: 'string',
      fieldRequired: false
    },
    body: {
      title: 'Treść szablonu',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
